
//获取文件MD5
const SparkMD5 = require('spark-md5');
const getFileMd5 = (file, callback) => {
	const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
	const fileReader = new FileReader();
	const chunkSize = 2097152;
	const chunks = Math.ceil(file.size / chunkSize);
	let currentChunk = 0;
	const spark = new SparkMD5.ArrayBuffer();
	fileReader.onload = function (e) {
		spark.append(e.target.result)
		currentChunk++
		if (currentChunk < chunks) {
			loadNext()
		} else {
			callback && callback(spark.end());
		}
	}
	fileReader.onerror = function () {
		console.warn('FileReader error.')
	}

	function loadNext() {
		const start = currentChunk * chunkSize
		const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize
		// 注意这里的 fileRaw
		fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
	}

	loadNext()
}

/**
 * 是否登录
 * @returns {boolean}
 */
const isLogin = () => {
	let vuex_user = localStorage.getItem('vuex_user');
	return vuex_user ? true : false;
}

/**
 * 获取缩略图
 * @returns {boolean}
 */
const dcraw = require('dcraw');
const extractThumb = (file, callback) => {
	var reader = new FileReader();
	reader.onload = ((o) => {
		return (e) => {
			var buf = new Uint8Array(e.currentTarget.result);
			var thumbnail = dcraw(buf, { extractThumbnail: true });
			var blob = new Blob([thumbnail], { type: "image/jpeg" });
			var urlCreator = window.URL || window.webkitURL;
			var imageUrl = urlCreator.createObjectURL(blob);
			file.raw.thumbblob = blob;
			file.raw.thumburl = imageUrl;
			callback(file);
		};
	})(file.raw);
	reader.readAsArrayBuffer(file.raw);
}

/**
 * http原生请求
 * @param options
 * @param callback
 */
const httpAjax = (options, callback) => {
	var ajax = new XMLHttpRequest();
	if (options.method.toUpperCase() == 'POST') {
		ajax.open("POST", options.url);
		ajax.send(options.params);
	} else {
		let url = options.url;
		if (typeof options.params == "string") {
			url+="?"+options.params;
		}
		ajax.open("GET", url);
		ajax.send(url);
	}
	ajax.onreadystatechange = function () {
		if (ajax.readyState==4 &&ajax.status==200) {
			callback(eval('('+ajax.responseText+')'));
		}
	}
}

const JSZip = require('jszip');
const FileSaver = require('file-saver');
const downFile = (files, title, callback) => {
	let zip = new JSZip();
	let promises = [];
	let index = 1;
	for (let file of files) {
		file = file.replace('http:', 'https:');
		const promise = getImgArrayBuffer(file).then(data => {
			let filename = getFilenameFromUrl(file);
			let exf = filename.split(".");
			filename = title + '_' + (index++) + '.' + exf[1];
			// 下载文件, 并存成ArrayBuffer对象(blob)
			zip.file(filename, data, { binary: true }); // 逐个添加文件
		});
		promises.push(promise);
	}
	Promise.all(promises).then(() => {
		zip.generateAsync({ type: "blob" }).then(content => {
			// 生成二进制流
			FileSaver.saveAs(content, title); // 利用file-saver保存文件  自定义文件名
			callback();
		});
	}).catch(res=>{
		console.log("文件压缩失败")
	});
}

//通过url 转为blob格式的数据
const getImgArrayBuffer = (url) => {
	return new Promise((resolve, reject) => {
		//通过请求获取文件blob格式
		let xmlhttp = new XMLHttpRequest();
		xmlhttp.open("GET", url, true);
		xmlhttp.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0, must-revalidate");
		xmlhttp.responseType = "blob";
		xmlhttp.onload = function () {
			if (this.status == 200) {
				resolve(this.response);
			}else{
				reject(this.status);
			}
		}
		xmlhttp.send();
	});
}

const getFilenameFromUrl = (url) => {
	const pathname = new URL(url).pathname;
	const index = pathname.lastIndexOf('/');
	return (-1 !== index) ? pathname.substring(index + 1) : pathname;
}

// 获取URL文件后缀
const getFileExtension = (url) => {
	// 使用正则表达式匹配URL中的文件扩展名
	const match = url.match(/\.(\w{2,4})(?:$|\?|#)/);
	return match ? match[1] : null;
}

module.exports = {
	getFileMd5,
	isLogin,
	httpAjax,
	extractThumb,
	downFile,
	getImgArrayBuffer,
	getFilenameFromUrl,
	getFileExtension
}